import { loginOutAndCallbackUrl } from "@/utils/api/keyConnect.js";

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  // const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  const format = cFormat || "{y}/{m}/{d}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

export function goKeyPear(e) {
  loginOutAndCallbackUrl().then((res) => {
    if (res.code === 200) {
      localStorage.removeItem("issuer");
      localStorage.removeItem("planInfo");
 
      if (process.env.NODE_ENV == "development") {
        window.location.href = "http://192.168.1.2:8080/#/" + e;
      } else {
        window.location.href = `${res.data.substring(
          0,
          res.data.indexOf("#") + 2
        )}${e}`;
      }
    }
  });
}
